import React, { useState, useEffect, useRef } from "react";
import Select from "react-select";
import "bootstrap/dist/css/bootstrap.min.css";
import PopupInputFieldforObservation from "../PopupInputFieldforObservation";
import "../../.csscode/Table.css";
import { toast } from "sonner";
import CustomLoader from "../static/CustomLoader";
import { FaListUl, FaTimes } from "react-icons/fa";
import {
  uploadDocument,
  viewDocument,
  deleteDocument,
} from "../utiles/DocumentService";
import GenerateAIContentModal from "./GenerateAIContentModal";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";

/* ============================================================
   STYLES — scoped to the observation detail table layout
   ============================================================ */
const odStyles = `
.od-wrap { width: 100%; }

/* ---- Toggle / action buttons ---- */
/* ---- Toggle / action buttons ---- */
.od-actions {
  display: flex; align-items: center; flex-wrap: wrap;
  gap: 8px; margin-bottom: 16px;
}
.od-toggle {
  display: inline-flex; align-items: center; justify-content: center; gap: 8px;
  height: 40px; padding: 0 18px; margin: 0;
  box-sizing: border-box; line-height: 1; white-space: nowrap;
  border-radius: 8px; font-size: 14px; font-weight: 600;
  border: 1px solid transparent; cursor: pointer; user-select: none;
  transition: background-color .2s, box-shadow .2s, border-color .2s, transform .1s;
}
.od-toggle:active { transform: translateY(1px); }
.od-toggle--open  { background: #4f46e5; color: #fff; box-shadow: 0 2px 6px rgba(79,70,229,.3); }
.od-toggle--open:hover  { background: #4338ca; }
.od-toggle--close { background: #f59e0b; color: #fff; box-shadow: 0 2px 6px rgba(245,158,11,.3); }
.od-toggle--close:hover { background: #d97706; }

/* AI button – teal (was purple) */
.od-toggle--ai    { background: #0d9488; color: #fff; box-shadow: 0 2px 6px rgba(13,148,136,.35); }
.od-toggle--ai:hover { background: #0f766e; }
.od-toggle--ai svg { font-size: 18px; }

/* ---- Chapter card ---- */
.od-chapter {
  margin-bottom: 24px;
  border: 1px solid #cbd5e1;
  border-radius: 12px;
  overflow: hidden;
  background: #fff;
  box-shadow: 0 1px 3px rgba(15,23,42,.05);
  scroll-margin-top: 80px;
}
.od-chapter-header {
  background: linear-gradient(90deg, #1e293b 0%, #334155 100%);
  color: #fff;
  font-weight: 700;
  font-size: 14px;
  letter-spacing: .2px;
  padding: 10px 16px;
}
  .od-chapter:focus { outline: none; }
.od-chapter--highlight {
  border-color: #4f46e5;
  animation: odChapterPulse 1.8s ease-out;
}
@keyframes odChapterPulse {
  0%   { box-shadow: 0 0 0 0 rgba(79,70,229,.55); }
  100% { box-shadow: 0 0 0 14px rgba(79,70,229,0); }
}

/* ---- Question table (4-column layout, auto sizes) ---- */
.od-q-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13.5px;
  background: #fff;
  table-layout: auto;
}
.od-q-table + .od-q-table { border-top: 2px solid #e2e8f0; }
.od-q-table td {
  border: 1px solid #cbd5e1;
  padding: 10px 12px;
  vertical-align: top;
  word-wrap: break-word;
  overflow-wrap: anywhere;
}

/* Question header row */
.od-q-table .od-q-header {
  background: #f1f5f9;
  color: #1e293b;
  font-weight: 700;
  font-size: 14px;
  padding: 8px 12px;
}

/* Label cells — hug content */
.od-q-table .od-label {
  width: 1px;
  white-space: nowrap;
  background: #f8fafc;
  font-weight: 600;
  color: #1e293b;
  font-size: 13px;
}

/* Value cells */
.od-q-table .od-value { background: #fff; }

.od-q-header-cell {
  display: flex; align-items: center; gap: 10px;
  justify-content: space-between;
}
.od-q-header-left { display: inline-flex; align-items: center; gap: 10px; min-width: 0; }
.od-serial {
  display: inline-flex; align-items: center; justify-content: center;
  min-width: 26px; height: 26px; padding: 0 8px;
  border-radius: 6px;
  background: #1e293b; color: #fff;
  font-size: 12px; font-weight: 700;
  flex: 0 0 auto;
}
.od-del-btn {
  display: inline-flex; align-items: center; gap: 4px;
  height: 28px; padding: 0 10px;
  border-radius: 6px;
  background: #fff; color: #dc2626;
  border: 1px solid #fca5a5;
  font-size: 12px; font-weight: 600;
  cursor: pointer;
  transition: background-color .15s, border-color .15s;
}
.od-del-btn:hover { background: #fef2f2; border-color: #dc2626; }

/* Add Row button */
.od-addrow-btn {
  display: inline-flex; align-items: center; gap: 6px;
  margin: 12px 16px 16px;
  height: 34px; padding: 0 14px;
  border-radius: 8px;
  background: #16a34a; color: #fff;
  border: none;
  font-size: 13px; font-weight: 600;
  cursor: pointer;
  box-shadow: 0 2px 4px rgba(22,163,74,.25);
  transition: background-color .15s, box-shadow .2s;
}
.od-addrow-btn:hover { background: #15803d; box-shadow: 0 4px 10px rgba(22,163,74,.35); }

/* Chapter select row */
.od-select-wrap { margin-bottom: 16px; }
.od-select-label {
  display: block; margin: 0 0 6px;
  font-size: 13px; font-weight: 600; color: #334155;
}

/* ---- Image grid ---- */
.od-img-grid {
  display: flex; flex-wrap: wrap; gap: 12px;
  margin-top: 10px; padding: 10px;
  border: 1px dashed #cbd5e1; border-radius: 8px;
  background: #f8fafc;
}
.od-img-card {
  position: relative;
  width: 96px; height: 116px;
  border: 1px solid #e2e8f0; border-radius: 8px;
  background: #fff;
  display: flex; flex-direction: column; align-items: center;
  padding: 6px;
  box-shadow: 0 1px 3px rgba(15,23,42,.06);
}
.od-img-card img {
  width: 100%; height: 68px;
  object-fit: cover; border-radius: 6px;
  cursor: pointer;
  background: #e2e8f0;
  color: #64748b;
  font-size: 11px;
}
  .od-img-ph {
  width: 100%; height: 68px;
  border-radius: 6px;
  background: #e2e8f0; color: #64748b;
  font-size: 11px;
  display: flex; align-items: center; justify-content: center;
  text-align: center;
}
.od-img-card .od-img-del {
  position: absolute; top: 5px; right: 5px;
  width: 22px; height: 22px;
  border-radius: 50%;
  background: #fee2e2; color: #b91c1c;
  border: none;
  font-size: 14px; font-weight: bold;
  display: flex; align-items: center; justify-content: center;
  cursor: pointer;
  box-shadow: 0 1px 3px rgba(0,0,0,.1);
}
.od-img-card .od-img-del:hover { background: #fecaca; }
.od-img-card .od-img-name {
  font-size: 10px; color: #475569;
  text-align: center;
  margin-top: 6px;
  width: 100%;
  overflow: hidden; text-overflow: ellipsis; white-space: nowrap;
}

/* ============================================================
   FLOATING BUTTONS
   ============================================================ */

/* Common FAB style */
.od-fab {
  width: 50px; height: 50px; border-radius: 50%;
  color: #fff;
  display: flex; align-items: center; justify-content: center;
  border: none; cursor: pointer;
  box-shadow: 0 4px 12px rgba(15,23,42,.25);
  transition: transform .15s, background-color .2s, box-shadow .2s;
}
.od-fab:hover { transform: translateY(-2px); box-shadow: 0 6px 16px rgba(15,23,42,.3); }
.od-fab:focus-visible { outline: 3px solid rgba(79,70,229,.35); outline-offset: 2px; }
.od-fab:active { transform: translateY(0); }
.od-fab svg { font-size: 22px; }
.od-fab--ai {
  position: fixed;
  top: 310px;
  right: 24px;
  z-index: 2002;
  background: #0d9488;
  box-shadow: 0 4px 12px rgba(13,148,136,.4);
}
.od-fab--ai:hover { background: #0f766e; box-shadow: 0 6px 16px rgba(13,148,136,.5); }
.od-fab--ai:focus-visible { outline: 3px solid rgba(13,148,136,.4); outline-offset: 2px; }

/* Chapter FAB — right side, above the up/down scroll buttons */
.od-fab--chapter {
  position: fixed;
  right: 22px;
  bottom: 210px;
  z-index: 2002;
  background: #4f46e5;
  box-shadow: 0 4px 12px rgba(79,70,229,.4);
}
.od-fab--chapter:hover { background: #4338ca; box-shadow: 0 6px 16px rgba(79,70,229,.5); }

/* ---- Sliding drawer ---- */
.od-drawer {
  position: fixed; top: 0; height: 100%; width: 280px;
  background: #fff;
  box-shadow: 0 0 20px rgba(0,0,0,.2);
  transition: right .3s ease-in-out;
  z-index: 2001;
  display: flex; flex-direction: column;
}
.od-drawer-head {
  background: linear-gradient(90deg, #1e293b 0%, #334155 100%);
  color: #fff;
  display: flex; align-items: center; justify-content: space-between;
  padding: 12px 16px; font-weight: 700;
}
.od-drawer-head svg { cursor: pointer; font-size: 18px; }
.od-drawer-search { padding: 10px; border-bottom: 1px solid #eee; }
.od-drawer-search input {
  width: 100%; padding: 8px; border-radius: 6px;
  border: 1px solid #cbd5e1; font-size: 13px; outline: none;
}
.od-drawer-search input:focus { border-color: #4f46e5; box-shadow: 0 0 0 3px rgba(79,70,229,.15); }
.od-drawer-list { overflow-y: auto; flex: 1; }
.od-drawer-item {
  padding: 10px 14px;
  cursor: pointer;
  border-bottom: 1px solid #f1f5f9;
  font-size: 13.5px;
  transition: background .15s;
}
.od-drawer-item:hover { background: #f8fafc; }
.od-drawer-empty { padding: 12px; color: #94a3b8; text-align: center; font-size: 13px; }

/* ---- Full preview overlay ---- */
.od-preview-overlay {
  position: fixed; inset: 0;
  background: rgba(0,0,0,.8);
  display: flex; align-items: center; justify-content: center;
  z-index: 9999; cursor: pointer;
}
.od-preview-overlay img {
  max-width: 90%; max-height: 90%;
  border-radius: 12px;
}

/* ---- Confirm dialog ---- */
.od-confirm-overlay {
  position: fixed; inset: 0;
  background: rgba(15,23,42,.5);
  display: flex; align-items: center; justify-content: center;
  z-index: 10000;
}
.od-confirm-box {
  background: #fff;
  width: 92%; max-width: 380px;
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 10px 30px rgba(0,0,0,.25);
}
.od-confirm-title { font-size: 16px; font-weight: 700; color: #1e293b; margin: 0 0 8px; }
.od-confirm-text { font-size: 14px; color: #475569; margin: 0 0 18px; }
.od-confirm-actions { display: flex; justify-content: flex-end; gap: 8px; }
.od-confirm-btn {
  height: 36px; padding: 0 16px;
  border-radius: 8px; border: 1px solid transparent;
  font-size: 13.5px; font-weight: 600; cursor: pointer;
}
.od-confirm-btn--cancel { background: #fff; color: #334155; border-color: #cbd5e1; }
.od-confirm-btn--cancel:hover { background: #f1f5f9; }
.od-confirm-btn--ok { background: #4f46e5; color: #fff; }
.od-confirm-btn--ok:hover { background: #4338ca; }
.od-confirm-btn--danger { background: #dc2626; color: #fff; }
.od-confirm-btn--danger:hover { background: #b91c1c; }

/* Chapter header with delete button */
.od-chapter-header--row {
  display: flex; align-items: center; justify-content: space-between; gap: 10px;
}
.od-chapter-del-btn {
  height: 28px; padding: 0 12px;
  border-radius: 6px;
  background: rgba(255,255,255,.12); color: #fff;
  border: 1px solid rgba(255,255,255,.45);
  font-size: 12px; font-weight: 600; cursor: pointer;
  white-space: nowrap;
  transition: background-color .15s, border-color .15s;
}
.od-chapter-del-btn:hover { background: #dc2626; border-color: #dc2626; }

/* ---- Responsive ---- */
@media (max-width: 900px) {
  .od-q-table { font-size: 13px; }
  .od-q-table .od-label { font-size: 12.5px; }
}
@media (max-width: 600px) {
  .od-q-table { font-size: 12.5px; }
  .od-q-table td { padding: 8px 8px; }
  .od-q-table .od-label { white-space: normal; }
  .od-fab { width: 44px; height: 44px; }
  .od-fab svg { font-size: 20px; }
  .od-fab--ai { top: 260px; right: 14px; }
  .od-fab--chapter { right: 14px; bottom: 180px; }
}
`;

const getMimeType = (name = "") => {
  const ext = name.split(".").pop().toLowerCase();
  if (ext === "pdf") return "application/pdf";
  if (ext === "png") return "image/png";
  if (ext === "gif") return "image/gif";
  if (ext === "webp") return "image/webp";
  return "image/jpeg";
};

/* Small thumbnail: loads on mount, click opens full size in a new tab */
const ImageThumb = ({ fileName, folderPath, envCode }) => {
  const [src, setSrc] = useState(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    let cancelled = false;
    let createdUrl = null;
    setSrc(null);
    setFailed(false);
    if (!fileName) return;

    if (fileName.startsWith("blob:") || fileName.startsWith("http")) {
      setSrc(fileName);
      return;
    }

    (async () => {
      try {
        const response = await viewDocument({
          projectCode: "Ptw",
          envCode,
          folderPath,
          fileName,
        });
        if (cancelled) return;
        if (!response || response.cd === 1) {
          setFailed(true);
          return;
        }
        const binary = atob(response);
        const bytes = new Uint8Array(binary.length);
        for (let i = 0; i < binary.length; i++) bytes[i] = binary.charCodeAt(i);
        createdUrl = URL.createObjectURL(
          new Blob([bytes], { type: getMimeType(fileName) }),
        );
        setSrc(createdUrl);
      } catch (err) {
        if (!cancelled) setFailed(true);
        console.error("Thumbnail error:", err);
      }
    })();

    return () => {
      cancelled = true;
      if (createdUrl) URL.revokeObjectURL(createdUrl);
    };
  }, [fileName, folderPath, envCode]);

  if (failed) return <div className="od-img-ph">No preview</div>;
  if (!src) return <div className="od-img-ph">Loading…</div>;

  return (
    <img
      src={src}
      alt={fileName}
      title="Click to open in new tab"
      onClick={() => window.open(src, "_blank", "noopener,noreferrer")}
      onError={() => setFailed(true)}
    />
  );
};

const ObservationDetails = ({
  selectedDatacode,
  chapterList,
  questionList,
  divcodeList,
  statusOptions,
  annextureList,
  details,
  setDetails,
  handlesubmit,
  mode,
  showObsAIModal,
  setShowObsAIModal,
}) => {
  const [selectedChapters, setSelectedChapters] = useState([]);
  const [showChapters, setShowChapters] = useState(false);
  const [showChapterMenu, setShowChapterMenu] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const today = new Date().toISOString().split("T")[0];
  const [previewImg, setPreviewImg] = useState(null);
  const orgcode = localStorage.getItem("custCode") || "ptw";
  const envCode = localStorage.getItem("envcode") || "Prod";
  const apiUrl = localStorage.getItem("apiUrl");
  const chapterRefs = useRef({});

  const [loading, setLoading] = useState(false);
  const [scrollTarget, setScrollTarget] = useState(null);
  const [highlightChapter, setHighlightChapter] = useState(null);
  const [confirmChapter, setConfirmChapter] = useState(null);
  const [deleteConfirm, setDeleteConfirm] = useState(null);

  const dbTokenData = localStorage.getItem("dbTokenData");
  const headers = {
    Authorization: `Bearer ${dbTokenData}`,
    "Content-Type": "application/json",
    dbMaster: "",
  };

  const obsAIRows = details.map((item, idx) => ({
    key: String(idx),
    label: item.question ? item.question : `Observation ${idx + 1}`,
    content: item.observation || "",
  }));

  const initialObsAiContent = details.reduce((acc, item, idx) => {
    acc[String(idx)] = item.aiObservation || "";
    return acc;
  }, {});

  const initialObsAiSuggestion = details.reduce((acc, item, idx) => {
    acc[String(idx)] = item.aiSuggestion || "";
    return acc;
  }, {});

  const handleConfirmObsAI = (
    aiMap,
    editedCurrentContentMap,
    aiSuggestionMap = {},
  ) => {
    const updated = [...details];
    Object.keys(aiMap).forEach((key) => {
      const idx = parseInt(key, 10);
      if (!updated[idx]) return;

      const newAiSuggestion = aiSuggestionMap[key] || "";

      updated[idx] = {
        ...updated[idx],
        aiObservation: aiMap[key] || "",
        aiSuggestion: newAiSuggestion,
        observation:
          editedCurrentContentMap && editedCurrentContentMap[key] !== undefined
            ? editedCurrentContentMap[key]
            : updated[idx].observation,
        // fill the Suggestion field; keep the existing text if AI gave nothing
        suggestion: newAiSuggestion || updated[idx].suggestion,
      };

      if (mode === "A") {
        const remark = JSON.parse(updated[idx].remark || "{}");
        remark.observation = updated[idx].observation;
        remark.aiObservation = updated[idx].aiObservation;
        remark.aiSuggestion = updated[idx].aiSuggestion;
        updated[idx].remark = JSON.stringify(remark);
      }
    });
    setDetails(updated);
    setShowObsAIModal(false);
  };

  const filteredChapters = chapterList.filter((chapter) =>
    `${chapter.label} ${chapter.label2}`
      .toLowerCase()
      .includes(searchTerm.toLowerCase()),
  );

  /* ---------- image fetch & preview ---------- */
  const fetchAndPreviewImage = async (filename) => {
    const folderPath = `${orgcode}/sc_${selectedDatacode}`;
    setLoading(true);
    try {
      const response = await viewDocument({
        projectCode: "Ptw",
        envCode,
        folderPath,
        fileName: filename,
      });
      if (response.cd === 1) return "";

      const base64Data = response;
      const mimeType = filename.toLowerCase().endsWith(".pdf")
        ? "application/pdf"
        : "image/*";

      const binaryString = atob(base64Data);
      const bytes = new Uint8Array(binaryString.length);
      for (let i = 0; i < binaryString.length; i++) {
        bytes[i] = binaryString.charCodeAt(i);
      }
      const blob = new Blob([bytes], { type: mimeType });
      setPreviewImg(URL.createObjectURL(blob));
    } catch (err) {
      toast.error("Failed to load image.");
      console.error("Preview error:", err);
    } finally {
      setLoading(false);
    }
  };

  const fetchAndPreviewResponseImage = async (filename, dep) => {
    const folderPath = `${orgcode}/sc_${selectedDatacode}/dep_${dep}`;
    setLoading(true);
    try {
      const response = await viewDocument({
        projectCode: "Ptw",
        envCode,
        folderPath,
        fileName: filename,
      });
      if (response.cd === 1) return "";

      const base64Data = response;
      const mimeType = filename.toLowerCase().endsWith(".pdf")
        ? "application/pdf"
        : "image/*";

      const binaryString = atob(base64Data);
      const bytes = new Uint8Array(binaryString.length);
      for (let i = 0; i < binaryString.length; i++) {
        bytes[i] = binaryString.charCodeAt(i);
      }
      const blob = new Blob([bytes], { type: mimeType });
      setPreviewImg(URL.createObjectURL(blob));
    } catch (err) {
      toast.error("Failed to load image.");
      console.error("Preview error:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (details && details.length > 0) {
      const uniqueChapters = [...new Set(details.map((d) => d.chapter))];
      setSelectedChapters(uniqueChapters);
    } else {
      setSelectedChapters([]);
      setShowChapters(false);
    }
  }, [chapterList]);

  useEffect(() => {
    if (details && details.length > 0) {
      const uniqueChapters = [...new Set(details.map((d) => d.chapter))];
      setSelectedChapters(uniqueChapters);
    } else {
      setSelectedChapters([]);
      setShowChapters(false);
    }
  }, [details]);

  useEffect(() => {
    if (scrollTarget === null) return;
    const el = chapterRefs.current[scrollTarget];
    if (!el) return;

    el.scrollIntoView({ behavior: "smooth", block: "start" });
    el.focus({ preventScroll: true });
    setHighlightChapter(scrollTarget);
    setScrollTarget(null);

    setTimeout(() => setHighlightChapter(null), 2000);
  }, [scrollTarget, details]);

  const scrollToChapter = (chapterCode) => {
    const el = chapterRefs.current[chapterCode];
    if (!el) return;
    el.scrollIntoView({ behavior: "smooth", block: "start" });
    el.focus({ preventScroll: true });
  };

  /* Single entry point for all "select chapter" actions */
  const handleChapterSelect = (chapterCode) => {
    if (chapterCode === "" || chapterCode === undefined || chapterCode === null)
      return;

    // Already added → just jump to it
    const exists = details.some((d) => d.chapter === chapterCode);
    if (exists) {
      scrollToChapter(chapterCode);
      return;
    }

    // New chapter → open the confirm dialog
    setConfirmChapter(chapterCode);
  };

  /* Called when user clicks "Add" in the dialog */
  const confirmAddChapter = () => {
    const code = confirmChapter;
    setConfirmChapter(null);
    if (code === null) return;

    handleAddRow(code);
    setScrollTarget(code);

    // safety: drop the pending scroll if nothing got rendered
    setTimeout(() => setScrollTarget(null), 1500);
  };
  /* ---------- row / chapter handlers (unchanged logic) ---------- */
  const handleAddRow = (chapterCode) => {
    const chapterQuestions = questionList.filter(
      (q) => q.chaptercode === chapterCode,
    );
    const existingQuestions = details
      .filter((d) => d.chapter === chapterCode)
      .map((d) => d.questionId);

    if (chapterCode === 1) {
      const alreadyAdded = selectedChapters.includes(chapterCode);
      if (alreadyAdded) {
        alert("This chapter is already added.");
        return;
      }
      const maxId = Math.max(...details.map((d) => d.questionId || 0), 0);
      const newQuestionId = maxId + 1;
      setDetails((prev) => [
        ...prev,
        {
          chapter: chapterCode,
          question: "",
          questionId: newQuestionId,
          parent: 0,
          observation: "",
          aiObservation: "",
          suggestion: "",
          image: [],
          department: "",
          startdate: today,
          enddate: today,
          status: "",
          chapterStatus: 1,
          annexure: "",
          response: "",
          responseImages: [],
          remark: JSON.stringify({
            chapter: chapterCode,
            question: "",
            observation: "",
            aiObservation: "",
            image: [],
          }),
        },
      ]);
      setSelectedChapters((prev) => [...prev, chapterCode]);
      return;
    }

    const remainingQuestionObjs = chapterQuestions.filter(
      (q) => !existingQuestions.includes(q.value),
    );

    if (selectedChapters.includes(chapterCode)) {
      if (remainingQuestionObjs.length === 0) {
        alert("This chapter is already added.");
        return;
      } else {
        const confirmAdd = window.confirm(
          "This chapter is already partially added. Do you want to add the remaining questions?",
        );
        if (!confirmAdd) return;
      }
    }

    const allRows = [];
    const mainQuestions = remainingQuestionObjs.filter(
      (q) => !q.parent || q.parent === 0,
    );
    mainQuestions.forEach((mq) => {
      allRows.push({
        chapter: chapterCode,
        question: mq.label,
        questionId: mq.value,
        parent: 0,
        observation: "",
        aiObservation: "",
        suggestion: "",
        image: [],
        department: "",
        startdate: today,
        enddate: today,
        status: 1,
        chapterStatus: 1,
        annexure: "",
        response: "",
        responseImages: [],
        remark: JSON.stringify({
          chapter: chapterCode,
          question: mq.label,
          observation: "",
          aiObservation: "",
          image: [],
        }),
      });

      const subQuestions = questionList.filter(
        (sq) => sq.parent === mq.value && !existingQuestions.includes(sq.value),
      );
      subQuestions.forEach((sq) => {
        allRows.push({
          chapter: chapterCode,
          question: sq.label,
          questionId: sq.value,
          parent: sq.parent,
          observation: "",
          aiObservation: "",
          suggestion: "",
          image: [],
          department: "",
          startdate: today,
          enddate: today,
          status: 1,
          chapterStatus: 1,
          annexure: "",
          response: "",
          responseImages: [],
          remark: JSON.stringify({
            chapter: chapterCode,
            question: sq.label,
            observation: "",
            aiObservation: "",
            image: [],
          }),
        });
      });
    });

    setDetails((prev) => [...prev, ...allRows]);
    if (!selectedChapters.includes(chapterCode)) {
      setSelectedChapters((prev) => [...prev, chapterCode]);
    }
  };

  const handleAddFreeRow = (chapterCode) => {
    const maxId = Math.max(...details.map((d) => d.questionId || 0), 0);
    const newQuestionId = maxId + 1;
    const newRow = {
      chapter: chapterCode,
      question: "",
      questionId: newQuestionId,
      parent: 0,
      observation: "",
      aiObservation: "",
      suggestion: "",
      image: [],
      department: "",
      startdate: today,
      enddate: today,
      status: 1,
      chapterStatus: 1,
      annexure: "",
      response: "",
      responseImages: [],
      remark: JSON.stringify({
        chapter: chapterCode,
        question: "",
        observation: "",
        aiObservation: "",
        image: [],
      }),
    };
    setDetails((prev) => [...prev, newRow]);
  };

  const handleChapterStatusChange = (chapterCode, status) => {
    const updated = details.map((item) => {
      if (item.chapter === chapterCode) {
        return { ...item, chapterStatus: status };
      }
      return item;
    });
    setDetails(updated);
  };
  /* Delete one file from the server AND from the form state */
  const removeFile = async ({ imgValue, index, type, folderPath }) => {
    if (!window.confirm(`If you proceed, file (${imgValue}) will be deleted.`))
      return;

    // 1) Delete from the server first (skip local-only blob/http files)
    const isLocalOnly =
      imgValue.startsWith("blob:") || imgValue.startsWith("http");
    if (!isLocalOnly) {
      setLoading(true);
      try {
        const response = await deleteDocument({
          projectCode: "Ptw",
          envCode,
          folderPath,
          fileName: imgValue,
        });
        if (response && response.cd === 1) {
          toast.error(response.description || "Server delete failed.");
          return; // keep the image so the user can retry
        }
      } catch (err) {
        toast.error("Server delete failed.");
        console.error("Server delete error:", err);
        return;
      } finally {
        setLoading(false);
      }
    }

    // 2) Remove from the form state (new row object, no mutation)
    setDetails((prev) =>
      prev.map((row, i) => {
        if (i !== index) return row;

        const newList = (row[type] || []).filter((img) => img !== imgValue);
        const updatedRow = { ...row, [type]: newList };

        // keep the saved copy (remark) in sync so it can't come back
        if (type === "image") {
          const remark = JSON.parse(row.remark || "{}");
          remark.image = newList;
          updatedRow.remark = JSON.stringify(remark);
        }
        return updatedRow;
      }),
    );

    toast.success(`Deleted: ${imgValue}`);
  };

  const deleteImage = (imgValue, index, type = "image") =>
    removeFile({
      imgValue,
      index,
      type,
      folderPath: `${orgcode}/sc_${selectedDatacode}`,
    });

  const deleteResponseImage = (imgValue, index, type = "responseImages", dep) =>
    removeFile({
      imgValue,
      index,
      type,
      folderPath: `${orgcode}/sc_${selectedDatacode}/dep_${dep}`,
    });

  const handleImageUpload = async (files, index, type = "image") => {
    if (!files || files.length === 0) return;

    const folderPath = `${orgcode}/sc_${selectedDatacode}`;
    const maxRetries = 3;
    const uploadedFiles = [];

    for (let file of files) {
      if (!["image/png", "image/jpeg"].includes(file.type)) {
        toast.warning(`${file.name} is not a valid JPG/PNG file.`);
        continue;
      }
      for (let attempt = 1; attempt <= maxRetries; attempt++) {
        setLoading(true);
        try {
          const uploadRes = await uploadDocument({
            file,
            projectCode: "Ptw",
            envCode,
            folderPath,
          });
          if (uploadRes?.cd === 1) {
            toast.error(uploadRes.description);
            setLoading(false);
            return;
          }
          uploadedFiles.push(uploadRes);
          break;
        } catch (err) {
          if (attempt === maxRetries)
            toast.error(`Failed to upload ${file.name}`);
        } finally {
          setLoading(false);
        }
      }
    }

    if (uploadedFiles.length) {
      const updated = [...details];
      const target = updated[index];
      const old = Array.isArray(target[type]) ? target[type] : [];
      const newList = [...old, ...uploadedFiles];
      target[type] = newList;

      if (type === "image" && mode === "A") {
        const remark = JSON.parse(target.remark || "{}");
        remark.image = newList;
        target.remark = JSON.stringify(remark);
      }
      setDetails(updated);
    }
  };

  const handleResponseImageUpload = async (
    files,
    index,
    type = "image",
    dep,
  ) => {
    if (!files || files.length === 0) return;
    if (!dep) {
      toast.warning(
        "Please select a department before uploading response images.",
      );
      return;
    }

    const folderPath = `${orgcode}/sc_${selectedDatacode}/dep_${dep}`;
    const maxRetries = 3;
    const uploadedFiles = [];

    for (let file of files) {
      if (!["image/png", "image/jpeg"].includes(file.type)) {
        toast.warning(`${file.name} is not a valid JPG/PNG file.`);
        continue;
      }
      for (let attempt = 1; attempt <= maxRetries; attempt++) {
        setLoading(true);
        try {
          const uploadRes = await uploadDocument({
            file,
            projectCode: "Ptw",
            envCode,
            folderPath,
          });
          if (uploadRes?.cd === 1) {
            toast.error(uploadRes.description);
            setLoading(false);
            return;
          }
          uploadedFiles.push(uploadRes);
          break;
        } catch (err) {
          if (attempt === maxRetries)
            toast.error(`Failed to upload ${file.name}`);
        } finally {
          setLoading(false);
        }
      }
    }

    if (uploadedFiles.length) {
      const updated = [...details];
      const target = updated[index];
      const old = Array.isArray(target[type]) ? target[type] : [];
      const newList = [...old, ...uploadedFiles];
      target[type] = newList;

      if (type === "image" && mode === "A") {
        const remark = JSON.parse(target.remark || "{}");
        remark.image = newList;
        target.remark = JSON.stringify(remark);
      }
      setDetails(updated);
    }
  };

  const handleChange = (index, field, value) => {
    const updated = [...details];
    updated[index][field] = value;

    if (
      mode === "A" &&
      (field === "observation" || field === "aiObservation")
    ) {
      const remark = JSON.parse(updated[index].remark || "{}");
      remark.observation = updated[index].observation || "";
      remark.aiObservation = updated[index].aiObservation || "";
      updated[index].remark = JSON.stringify(remark);
    }
    setDetails(updated);
  };

  const handleReset = (index) => {
    const original = JSON.parse(
      details[index].remark ? details[index].remark : "{}",
    );
    const updated = [...details];
    updated[index] = {
      ...updated[index],
      observation: original.observation,
      image: original.image,
      suggestion: "",
      startdate: today,
      enddate: today,
      response: "",
      responseImages: [],
    };
    setDetails(updated);
  };

  const handleDelete = (index) => {
    const updated = [...details];
    updated.splice(index, 1);
    setDetails(updated);
  };

  const handleDeleteChapter = (chapterCode) => {
    setDetails((prev) =>
      prev.filter((d) => String(d.chapter) !== String(chapterCode)),
    );
    setSelectedChapters((prev) =>
      prev.filter((c) => String(c) !== String(chapterCode)),
    );
  };

  const askDeleteQuestion = (index) =>
    setDeleteConfirm({ type: "question", index });

  const askDeleteChapter = (chapterCode) =>
    setDeleteConfirm({ type: "chapter", chapterCode });

  /* Called when user clicks "Delete" in the dialog */
  const confirmDelete = () => {
    if (!deleteConfirm) return;
    if (deleteConfirm.type === "question") {
      handleDelete(deleteConfirm.index);
    } else {
      handleDeleteChapter(deleteConfirm.chapterCode);
    }
    setDeleteConfirm(null);
  };

  /* ============================================================
     RENDER — chapters as audit-style tables (4-column layout)
     ============================================================ */
  const renderGroupedByChapter = () => {
    const grouped = {};
    details.forEach((item) => {
      if (!grouped[item.chapter]) grouped[item.chapter] = [];
      grouped[item.chapter].push(item);
    });

    return Object.keys(grouped).map((chapterCode) => {
      const chapterLabel = chapterList.find((c) => c.value == chapterCode);
      const chapterRows = grouped[chapterCode];
      let qCounter = 1;

      return (
        <div
          key={chapterCode}
          ref={(el) => (chapterRefs.current[chapterCode] = el)}
          className={`od-chapter ${
            String(highlightChapter) === String(chapterCode)
              ? "od-chapter--highlight"
              : ""
          }`}
          tabIndex={-1}
        >
          <div className="od-chapter-header od-chapter-header--row">
            <span>
              {chapterLabel?.label} — {chapterLabel?.label2}
            </span>
            <button
              type="button"
              className="od-chapter-del-btn"
              onClick={() => askDeleteChapter(chapterCode)}
              title="Delete this chapter"
            >
              Delete Chapter
            </button>
          </div>

          {chapterRows.map((item, index) => {
            const serial =
              item.parent && item.parent !== 0
                ? `${qCounter - 1}.${index + 1}`
                : `${qCounter++}`;
            const detailIdx = details.indexOf(item);
            const isModeU = mode && mode === "U";

            return (
              <table key={index} className="od-q-table">
                <tbody>
                  {/* ===== Question header with Delete button ===== */}
                  <tr>
                    <td colSpan={4} className="od-q-header">
                      <div className="od-q-header-cell">
                        <span className="od-q-header-left">
                          <span className="od-serial">{serial}</span>
                          <span>{item.question || "—"}</span>
                        </span>
                        <button
                          type="button"
                          className="od-del-btn"
                          onClick={() => askDeleteQuestion(detailIdx)}
                          title="Delete row"
                        >
                          Delete
                        </button>
                      </div>
                    </td>
                  </tr>

                  {/* ===== Row 1: Observation | AI Observation ===== */}
                  <tr>
                    <td className="od-label">Observation</td>
                    <td className="od-value">
                      <PopupInputFieldforObservation
                        name="observation"
                        label=""
                        value={item.observation}
                        onChange={(e) =>
                          handleChange(detailIdx, "observation", e.target.value)
                        }
                      />
                    </td>
                    <td className="od-label">AI Generated Observation</td>
                    <td className="od-value">
                      <PopupInputFieldforObservation
                        name="aiObservation"
                        label=""
                        value={item.aiObservation || ""}
                        onChange={(e) =>
                          handleChange(
                            detailIdx,
                            "aiObservation",
                            e.target.value,
                          )
                        }
                      />
                    </td>
                  </tr>

                  {/* ===== Row 2: Suggestion | Department ===== */}
                  <tr>
                    <td className="od-label">Suggestion</td>
                    <td className="od-value">
                      <PopupInputFieldforObservation
                        name="suggestion"
                        label=""
                        value={item.suggestion}
                        onChange={(e) =>
                          handleChange(detailIdx, "suggestion", e.target.value)
                        }
                      />
                    </td>
                    <td className="od-label">Department</td>
                    <td className="od-value">
                      <Select
                        options={[
                          { label: "Please select", value: "" },
                          ...divcodeList,
                        ]}
                        value={[
                          { label: "Please select", value: "" },
                          ...divcodeList,
                        ].find((opt) => opt.value === item.department)}
                        onChange={(e) =>
                          handleChange(detailIdx, "department", e.value)
                        }
                        placeholder="Department"
                      />
                    </td>
                  </tr>

                  {/* ===== Row 3: Images (spans) ===== */}
                  <tr>
                    <td className="od-label">Images</td>
                    <td colSpan={3} className="od-value">
                      <input
                        type="file"
                        className="form-control"
                        multiple
                        accept="image/*"
                        onChange={(e) =>
                          handleImageUpload(e.target.files, detailIdx, "image")
                        }
                      />
                      {item.image && item.image.length > 0 && (
                        <div className="od-img-grid">
                          {item.image.map((img, idx2) => (
                            <div key={idx2} className="od-img-card">
                              <ImageThumb
                                fileName={img}
                                folderPath={`${orgcode}/sc_${selectedDatacode}`}
                                envCode={envCode}
                              />
                              <button
                                type="button"
                                className="od-img-del"
                                title="Delete Image"
                                onClick={() =>
                                  deleteImage(img, detailIdx, "image")
                                }
                              >
                                ×
                              </button>
                              <span className="od-img-name" title={img}>
                                {img.split("/").pop()}
                              </span>
                            </div>
                          ))}
                        </div>
                      )}
                    </td>
                  </tr>

                  {/* ===== Row 4 (mode U): Annexure | Status ===== */}
                  {isModeU && (
                    <tr>
                      <td className="od-label">Annexure</td>
                      <td className="od-value">
                        <Select
                          options={[
                            { label: "Please select", value: "" },
                            ...annextureList,
                          ]}
                          value={[
                            { label: "Please select", value: "" },
                            ...annextureList,
                          ].find((opt) => opt.value === item.annexure)}
                          onChange={(e) =>
                            handleChange(detailIdx, "annexure", e.value)
                          }
                          placeholder="Annexure"
                        />
                      </td>
                      <td className="od-label">Status</td>
                      <td className="od-value">
                        <Select
                          options={[
                            { label: "Please select", value: "" },
                            ...statusOptions,
                          ]}
                          value={[
                            { label: "Please select", value: "" },
                            ...statusOptions,
                          ].find((opt) => opt.value === item.status)}
                          onChange={(e) =>
                            handleChange(detailIdx, "status", e.value)
                          }
                          placeholder="Status"
                        />
                      </td>
                    </tr>
                  )}

                  {/* ===== Row 5: Start Date | End Date (when department is set) ===== */}
                  {item.department && (
                    <tr>
                      <td className="od-label">
                        Start Date <span className="text-danger">*</span>
                      </td>
                      <td className="od-value">
                        <input
                          type="date"
                          className="form-control"
                          required
                          value={item.startdate}
                          onChange={(e) =>
                            handleChange(detailIdx, "startdate", e.target.value)
                          }
                        />
                      </td>
                      <td className="od-label">
                        End Date <span className="text-danger">*</span>
                      </td>
                      <td className="od-value">
                        <input
                          type="date"
                          className="form-control"
                          required
                          value={item.enddate}
                          onChange={(e) =>
                            handleChange(detailIdx, "enddate", e.target.value)
                          }
                        />
                      </td>
                    </tr>
                  )}

                  {/* ===== Row 6 (mode U): Response (spans) ===== */}
                  {isModeU && (
                    <tr>
                      <td className="od-label">Response</td>
                      <td colSpan={3} className="od-value">
                        <PopupInputFieldforObservation
                          name="response"
                          label=""
                          value={item.response || ""}
                          onChange={(e) =>
                            handleChange(detailIdx, "response", e.target.value)
                          }
                        />
                      </td>
                    </tr>
                  )}

                  {/* ===== Row 7 (mode U): Response Images (spans) ===== */}
                  {isModeU && (
                    <tr>
                      <td className="od-label">Response Images</td>
                      <td colSpan={3} className="od-value">
                        <input
                          type="file"
                          className="form-control"
                          multiple
                          accept="image/*"
                          onChange={(e) =>
                            handleResponseImageUpload(
                              e.target.files,
                              detailIdx,
                              "responseImages",
                              item.department,
                            )
                          }
                        />
                        {item.responseImages &&
                          item.responseImages.length > 0 && (
                            <div className="od-img-grid">
                              {item.responseImages.map((img, idx2) => (
                                <div key={idx2} className="od-img-card">
                                  <ImageThumb
                                    fileName={img}
                                    folderPath={`${orgcode}/sc_${selectedDatacode}/dep_${item.department}`}
                                    envCode={envCode}
                                  />
                                  <button
                                    type="button"
                                    className="od-img-del"
                                    title="Delete Image"
                                    onClick={() =>
                                      deleteResponseImage(
                                        img,
                                        detailIdx,
                                        "responseImages",
                                        item.department,
                                      )
                                    }
                                  >
                                    ×
                                  </button>
                                  <span className="od-img-name" title={img}>
                                    {img.split("/").pop()}
                                  </span>
                                </div>
                              ))}
                            </div>
                          )}
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            );
          })}

          {/* Add Row button (chapter 1 only) */}
          {chapterCode == 1 && (
            <button
              type="button"
              className="od-addrow-btn"
              onClick={() => handleAddFreeRow(parseInt(chapterCode))}
            >
              + Add Row
            </button>
          )}
        </div>
      );
    });
  };

  return (
    <>
      <style>{odStyles}</style>
      <div className="od-wrap">
        {loading && <CustomLoader />}

        {/* ---- Toggle buttons ---- */}
        <div className="od-actions">
          {!showChapters && (
            <button
              type="button"
              className="od-toggle od-toggle--open"
              onClick={() => setShowChapters(true)}
            >
              {details && details.length > 0
                ? "View Inspection Report"
                : "Add Inspection Report"}
            </button>
          )}

          {showChapters && (
            <button
              type="button"
              className="od-toggle od-toggle--close"
              onClick={() => setShowChapters(false)}
            >
              Close Inspection
            </button>
          )}

          {showChapters && details && details.length > 0 && (
            <button
              type="button"
              className="od-toggle od-toggle--ai"
              onClick={() => setShowObsAIModal(true)}
            >
              <AutoAwesomeIcon fontSize="small" />
              Generate AI Content
            </button>
          )}
        </div>
        {showChapters && (
          <>
            {!details.length && (
              <div className="od-select-wrap">
                <label className="od-select-label">
                  Select Chapter to Add Questions
                </label>
                <Select
                  options={[
                    { label: "Please select", value: "" },
                    ...chapterList.map((item) => ({
                      ...item,
                      label: `${item.label} - ${item.label2}`,
                    })),
                  ]}
                  onChange={(e) => e && handleChapterSelect(e.value)}
                  placeholder="Select Chapter"
                />
              </div>
            )}

            {renderGroupedByChapter()}

            {details.length > 0 && (
              <div className="od-select-wrap">
                <label className="od-select-label">Select New Chapter</label>

                <Select
                  options={[
                    { label: "Please select", value: "" },
                    ...chapterList.map((item) => ({
                      ...item,
                      label: `${item.label} - ${item.label2}`,
                    })),
                  ]}
                  menuPortalTarget={document.body}
                  menuPosition="fixed"
                  styles={{
                    menuPortal: (base) => ({
                      ...base,
                      zIndex: 99999,
                    }),
                    menu: (base) => ({
                      ...base,
                      zIndex: 99999,
                    }),
                  }}
                  value={null}
                  onChange={(e) => e && handleChapterSelect(e.value)}
                  placeholder="Select Chapter"
                />
              </div>
            )}
          </>
        )}

        {/* ---- Fullscreen image preview ---- */}
        {previewImg && (
          <div
            className="od-preview-overlay"
            onClick={() => setPreviewImg(null)}
          >
            <img src={previewImg} alt="Full Preview" />
          </div>
        )}

        {/* ---- AI Modal ---- */}
        {showObsAIModal && (
          <GenerateAIContentModal
            open={showObsAIModal}
            onClose={() => setShowObsAIModal(false)}
            onConfirm={handleConfirmObsAI}
            apiUrl={apiUrl}
            headers={headers}
            rows={obsAIRows}
            initialAiContent={initialObsAiContent}
            initialAiSuggestion={initialObsAiSuggestion}
          />
        )}

        {/* ================================================================
            FLOATING BUTTONS
            - AI FAB → right side, a little under the suggest button
                       (top: 310px; right: 24px; z-index: 2002)
            - Chapter FAB → right side, above the up/down scroll buttons
            ================================================================ */}

        {showChapters && !showObsAIModal && details && details.length > 0 && (
          <button
            type="button"
            className="od-fab od-fab--ai"
            onClick={() => setShowObsAIModal(true)}
            title="Generate AI Content"
            aria-label="Generate AI Content"
          >
            <AutoAwesomeIcon />
          </button>
        )}

        {/* Chapter FAB — right side, above up/down scroll buttons */}
        {showChapters && !showObsAIModal && !showChapterMenu && (
          <button
            type="button"
            className="od-fab od-fab--chapter"
            onClick={() => setShowChapterMenu(true)}
            title="Chapters"
            aria-label="Open chapters"
          >
            <FaListUl />
          </button>
        )}

        {/* ---- Sliding drawer ---- */}
        <div
          className="od-drawer"
          style={{ right: showChapterMenu ? "0" : "-280px" }}
        >
          <div className="od-drawer-head">
            <span>Chapters</span>
            <FaTimes onClick={() => setShowChapterMenu(false)} />
          </div>

          <div className="od-drawer-search">
            <input
              type="text"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              placeholder="Search chapters..."
            />
          </div>

          <div className="od-drawer-list">
            {filteredChapters.length > 0 ? (
              filteredChapters.map((chapter) => (
                <div
                  key={chapter.value}
                  className="od-drawer-item"
                  onClick={() => {
                    handleChapterSelect(chapter.value);
                    setShowChapterMenu(false);
                  }}
                >
                  {chapter.label} — {chapter.label2}
                </div>
              ))
            ) : (
              <div className="od-drawer-empty">No chapters found</div>
            )}
          </div>
        </div>
      </div>

      {/* ---- Confirm add chapter dialog ---- */}
      {confirmChapter !== null &&
        (() => {
          const info = chapterList.find((c) => c.value === confirmChapter);
          return (
            <div
              className="od-confirm-overlay"
              onClick={() => setConfirmChapter(null)}
            >
              <div
                className="od-confirm-box"
                onClick={(e) => e.stopPropagation()}
              >
                <h4 className="od-confirm-title">Add Chapter</h4>
                <p className="od-confirm-text">
                  Do you want to add{" "}
                  {info ? `"${info.label} - ${info.label2}"` : "this chapter"}?
                </p>
                <div className="od-confirm-actions">
                  <button
                    type="button"
                    className="od-confirm-btn od-confirm-btn--cancel"
                    onClick={() => setConfirmChapter(null)}
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    className="od-confirm-btn od-confirm-btn--ok"
                    onClick={confirmAddChapter}
                  >
                    Add
                  </button>
                </div>
              </div>
            </div>
          );
        })()}

      {/* ---- Confirm delete dialog (question / chapter) ---- */}
      {deleteConfirm &&
        (() => {
          let title, text;
          if (deleteConfirm.type === "question") {
            const q = details[deleteConfirm.index];
            title = "Delete Question";
            text = `Do you want to delete ${
              q?.question ? `"${q.question}"` : "this question"
            }?`;
          } else {
            const info = chapterList.find(
              (c) => String(c.value) === String(deleteConfirm.chapterCode),
            );
            const count = details.filter(
              (d) => String(d.chapter) === String(deleteConfirm.chapterCode),
            ).length;
            title = "Delete Chapter";
            text = `Do you want to delete ${
              info ? `"${info.label} - ${info.label2}"` : "this chapter"
            } and its ${count} question${count === 1 ? "" : "s"}?`;
          }
          return (
            <div
              className="od-confirm-overlay"
              onClick={() => setDeleteConfirm(null)}
            >
              <div
                className="od-confirm-box"
                onClick={(e) => e.stopPropagation()}
              >
                <h4 className="od-confirm-title">{title}</h4>
                <p className="od-confirm-text">{text}</p>
                <div className="od-confirm-actions">
                  <button
                    type="button"
                    className="od-confirm-btn od-confirm-btn--cancel"
                    onClick={() => setDeleteConfirm(null)}
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    className="od-confirm-btn od-confirm-btn--danger"
                    onClick={confirmDelete}
                  >
                    Delete
                  </button>
                </div>
              </div>
            </div>
          );
        })()}
    </>
  );
};

export default ObservationDetails;
